import { Fab, useTheme } from '@mui/material';
import { generatePath, Link } from 'react-router-dom';
import { paths } from '../../routing/Router/paths';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export const SpeedDialGoodDealArticleIA = () => {
  const theme = useTheme();

  return (
    <Link to={generatePath(paths.ARTICLE_IA)}>
      <Fab
        color="primary"
        sx={{
          position: 'fixed',
          bottom: theme.spacing(12),
          right: theme.spacing(3),
          zIndex: 1,
          bgcolor: '#4a62f4',
        }}
      >
        <AutoFixHighIcon />
      </Fab>
    </Link>
  );
};
